import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../context/LoadingContext";
import DataTable from "../Requirement/components/common/ReusableTable";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../Requirement/services/RequirementServices";
import EditIcon from "@mui/icons-material/Edit";
import { Switch, Tooltip, IconButton } from "@mui/material";
import dayjs from "dayjs";
import SearchFilter from "../Requirement/components/common/SearchFilter";
import { Button } from "@mui/material";
import AlertModal from "../Requirement/components/common/AlerModel";

const FPMatchingOffers = ({ activeUser, userInfo, handleOpenAddOffer,handleActionEditClick,handleCancelAddOffer,  loading, isBankListLoaded, selectedRfq }) => {
  const { setLoading } = useLoading();
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productDetails, setProductDetails] = useState({});
  const [INRToUsd] = useState(0.012);
  const [searchValues, setSearchValues] = useState({
    searchOfferProduct: "",
    searchOfferProductGrade: "",
    searchPriceRange: "",
  });

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000 USD" },
    { value: "1000-2000", label: "1000-2000 USD" },
    { value: "2000-5000", label: "2000-5000 USD" },
    { value: "Above-5000", label: "Above 5000 USD" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const loadProductList = useCallback(async () => {
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { Status: "ACTIVE" },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: { Status: "ACTIVE" },
          }),
        ]);

        const distinctProducts = Array.from(
          new Map(allProducts.map((p) => [p.ProductName, p])).values()
        );
        setProductList(distinctProducts);
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    }
  }, []);

  const loadProductGrades = useCallback(async (productName) => {
    try {
      const [allGrades] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 500,
          filterTerms: { ProductName: productName },
        }),
      ]);
      if (allGrades.items.length > 0) {
        setProductGradeList(allGrades.items);
      } else {
        setProductGradeList([]);
      }
    } catch (error) {
      console.error("Error loading product grades: ", error);
    }
  }, []);

  const getProductDetails = useCallback(async (productId) => {
    try {
      const response = await fetchData({
        target: "listProducts",
        userOrder: "ProductID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { ProductID: productId },
      });

      if (response.items && response.items.length > 0) {
        const product = response.items[0];
        setProductDetails({
          ProductName: product.ProductName,
          Grade: product.Grade,
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      setProductDetails({});
    }
  }, []);

  const convertToINR = useCallback(
    (usdValue) => {
      if (!usdValue || usdValue === "") return "0.00";
      const inrValue = parseFloat(usdValue) / INRToUsd;
      return isNaN(inrValue) ? "0.00" : inrValue.toFixed(2);
    },
    [INRToUsd]
  );

  const convertToUSD = useCallback(
    (inrValue) => {
      if (!inrValue || inrValue === "") return "0.00";
      const usdValue = parseFloat(inrValue) * INRToUsd;
      return isNaN(usdValue) ? "0.00" : usdValue.toFixed(2);
    },
    [INRToUsd]
  );

  const formatPrice = useCallback((price) => {
    if (!price || price === "") return "0.00";
    const numPrice = parseFloat(price);
    return isNaN(numPrice) ? "0.00" : numPrice.toFixed(2);
  }, []);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    try {
      return dayjs(dateString).format("DD-MM-YYYY");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  }, []);

  const fetchMatchingOffers = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      setSelectedOffer(null);
      setLoading(true);
      console.log('selectedRfq###',selectedRfq.Id);
      try {
        const body = {
          target: "listFinanceOffers",
          userOrder: "CreatedAt",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            BankID: userInfo[0].OrgId,
            FinanceRfqID: selectedRfq.Id,
          },
        };

        const response = await fetchData(body);
        if (Array.isArray(response.items) || Array.isArray(response)) {
          const items = response.items || response || [];
          const itemsWithShortlist = items.map((item) => ({
            ...item,
            IsShortlist:
              item.IsShortlist !== undefined ? item.IsShortlist : false,
          }));
           const modifiedItems = (itemsWithShortlist.items || itemsWithShortlist).map((item) => ({
          ...item,
          id: item.FinanceRfqOfferID,
        }));
          console.log(modifiedItems)
          setOfferList(modifiedItems);
          setTotalItems(response.total || 0);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error loading matching offers:", error);
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [
      pageSize,
      rowStart,
      setLoading,
      convertToINR,
    ]
  );

  const handleSearch = (searchValues) => {
    setRowStart(0);
    fetchMatchingOffers(searchValues, 0);
  };

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchMatchingOffers(searchValues, newRowStart);
  };

  const handleRowClick = (row, event) => {
    console.log("Offer row clicked:", row);
    console.log("Row structure:", Object.keys(row));
    setSelectedOffer(row);
    // Open AddOffer form in view mode with selected offer details
    handleOpenAddOffer({ offer: row, mode: "update" });
  };
const cancelButton = () => {
  handleCancelAddOffer(false)
}
  const handleOfferResponse = () => {
    console.log("Offer response handled");
    setSelectedOffer(null);
  };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [];
  const handleActionClick = (event, row, mode) => {
handleActionEditClick(event, row, mode)

  }
  const columns = [
    { id: "FinanceRfqOfferID", numeric: false, label: "FinanceRfqOfferID" },
    { id: "Instrument", numeric: false, label: "Instrument" },
    { id: "Currency", numeric: false, label: "Currency" },
    { id: "TotalCost", numeric: false, label: "Total Cost" },
    { id: "Status", numeric: false, label: "Status" },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
              id: "action",
              numeric: false,
              label: "Action",
              renderCell: (row) => (
                <div
                  className="edit-icon"
                  style={{
                    display: "flex",
                    gap: "2px",
                    alignItems: "center",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Tooltip title="Edit Requirement">
                    <IconButton
                      onClick={(e) => handleActionClick(e, row, "update")}
                      sx={{ color: "#de6b14" }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              ),
            },
  ];

  useEffect(() => {
    fetchMatchingOffers(searchValues);
  }, [
    rowStart,
    pageSize,
    fetchMatchingOffers,
    searchValues,
  ]);

  return (
    <div>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Matching Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
        <div className="button-group">
          <Button
            variant="contained"
            className="btn-action-re"
            color="primary"
            onClick={() => cancelButton()}
            // disabled={loading || !isBankListLoaded || !userInfo[0]?.OrgId || !selectedRfq}
            
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn-action-re"
            color="primary"
            onClick={() => handleOpenAddOffer({ mode: "add" })}
            disabled={loading || !isBankListLoaded || !userInfo[0]?.OrgId || !selectedRfq}
           
          >
            Add Offer
          </Button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={offerList}
        total={totalItems}
        title="Matching Offers"
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        onRowClick={handleRowClick}
        selectedRows={selectedOffer ? [selectedOffer.id] : []}
      />
    </div>
  );
};

export default FPMatchingOffers;